import "./Contact.css";
import { MdEmail } from "react-icons/md";
import { FaLinkedin } from "react-icons/fa";

const Contact = (props) => {
  return (
    <div className="contact-main-container">
      <h1>Contact Me</h1>
      <h3>Want to chat?</h3>

      <p className="email">
        <MdEmail /> Email: boorom.hanna@gmail.com
      </p>
      <a
        href="https://www.linkedin.com/in/hanna-boorom/"
        rel="noreferrer"
        target="blank"
      >
        <FaLinkedin /> Connect with me on LinkedIn
      </a>
      <p>I look forward to being in contact!</p>
    </div>
  );
};

export default Contact;
